// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w83w","right":"styles_right__GrKh6"};